<template>
    <div>
        <!-- Type -->
        <noncustom-prop v-if="object.category"
            :object='object'
            :property='{label: object.category.label, column: "category"}'>
        </noncustom-prop>

        <!-- Author -->
        <noncustom-prop v-if="object.author"
            :object='object'
            link='searchable-actors-keyword'
            :property='{label: object.author.label, column: "author"}'>
        </noncustom-prop>

        <!-- Publisher -->
        <noncustom-prop v-if="object.publisher"
            :object='object'
            link='searchable-actors-keyword'
            :property='{label: object.publisher.label, column: "publisher"}'>
        </noncustom-prop>

        <!-- In/Title Info (Marc says to remove this in phone call on 7/13/2017) -->
        <noncustom-prop v-if="object.categ_18"
            :object='object'
            :property='{label: object.categ_18.label, column: "categ_18"}'>
        </noncustom-prop>

        <!-- Custom Catalog -->
        <noncustom-prop v-if="object.custom_catalog"
            :object='object'
            :property='{label: object.custom_catalog.label, column: "custom_catalog"}'>
        </noncustom-prop>

        <!-- Call Number -->
        <noncustom-prop v-if="object.custom_call_number"
            :object='object'
            :property='{label: object.custom_call_number.label, column: "custom_call_number"}'>
        </noncustom-prop>
    </div>
</template>

<script>
    import ManageProperties from './../../mixins/manageProperties.js'
    import NoncustomVue from './parts/noncustom.vue'
    import ViewRelated from './../../mixins/viewRelated.js'

    export default {
        props: ['object'],
        components: {
            'noncustom-prop': NoncustomVue,
        },
        mixins: [ManageProperties, ViewRelated],
    };
</script>
